import Flatpickr from 'stimulus-flatpickr'

// you can also import a translation file
import { Mandarin } from 'flatpickr/dist/l10n/zh.js'

// create a new Stimulus controller by extending stimulus-flatpickr wrapper controller
export default class extends Flatpickr {
  static values = {
    config: {
      type: Object,
      default: {
        enableTime: false,
      }
    }
  }
  initialize() {
    // sets your language (you can also set some global setting for all time pickers)
    this.config = {
      ...this.configValue,
      time_24hr: true,
      locale: {
        ...Mandarin,
        firstDayOfWeek: 1
      }
    }
  }

  // all flatpickr hooks are available as callbacks in your Stimulus controller
  change(selectedDates, dateStr, instance) {
    console.log('the callback returns the selected dates', selectedDates)
    console.log('but returns it also as a string', dateStr)
    console.log('and the flatpickr instance', instance)
  }
}
